import { AxiosPromise, AxiosStatic } from "axios";
import {
  ActiveLossEventForMe,
  InvestorLossEventDocument,
  LossEventBuybackChoice,
  SubmitBuybackResponseResult,
} from "../types/loss-events";

export const getActiveLossEventsForMe =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<ActiveLossEventForMe[]> =>
    await appAxios.get(`${serverURL}/loss-events/active-for-me`, {
      withCredentials: true,
    });

export const submitLossEventBuybackResponse =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    lossEventId: string,
    data: { choice: LossEventBuybackChoice; consentConfirmed?: boolean }
  ): AxiosPromise<SubmitBuybackResponseResult> =>
    await appAxios.post(
      `${serverURL}/loss-events/${encodeURIComponent(lossEventId)}/buyback-response`,
      data,
      {
        withCredentials: true,
      }
    );

export const getLossEventSpaPreview =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (lossEventId: string): AxiosPromise<Blob> =>
    await appAxios.get(
      `${serverURL}/loss-events/${encodeURIComponent(lossEventId)}/spa-preview`,
      {
        responseType: "blob",
        withCredentials: true,
      }
    );

export const getLossEventDocuments =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (lossEventId: string): AxiosPromise<InvestorLossEventDocument[]> =>
    await appAxios.get(
      `${serverURL}/loss-events/${encodeURIComponent(lossEventId)}/documents`,
      {
        withCredentials: true,
      }
    );
